import { useFlag } from "@/hooks/use-flag";
import { Flags } from "@/feature-flags";
import { type FC } from "react";
import { Banner } from "@/components/flexkit/Banner";

export const GlobalOverloadBanner: FC = () => {
    const { value: globalOverloadPercentage } = useFlag(Flags.GlobalOverload, 0);

    // Show banner if percentage is greater than 0
    if (globalOverloadPercentage <= 0) {
        return null;
    }

    return (
        <Banner
            className="mb-2 shadow-none"
            text="Ona is currently experiencing high demand. You may encounter intermittent issues as we scale our infrastructure."
            variant="warning"
            role="alert"
            aria-live="assertive"
        />
    );
};
